/*-----------------------------------------------------------------
- Schedule demo
-----------------------------------------------------------------*/
export default {
    title             : 'Schedule Demo',
    contact_us_text   : 'If you have any immediate questions, please feel free to contact us at $hello@Quarkino.com$',
    interested_service: 'Interested Service',
    select_service    : 'Select a Service',
    file              : 'File',
    demo_req_submitted: 'Demo Request Submitted!',
    can_schedule      : 'You can now schedule your demo.',
    full_name         : 'Full Name',
    email_address     : 'Email Address',
    uploader_content  : 'Attach file',
};
